import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import ProductImage from "./ProductImage";
import ProductInfo from "./ProductInfo/ProductInfo";
import ProductRecomendations from "./ProductRecomendations";
import ProductParams from "./ProductParams";
import ProductCEO from "./ProductCEO";
import { useParams } from "react-router";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../services/hooks";
import ProductTables from "./ProductTables";
import { fetchProduct } from "../../stores/product/productSlice";
import SpinnerContainer from "../../components/Spinner/SpinnerContainer";
import ProductDescription from "./ProductDescription";

export default function ProductPage() {
    const { productName } = useParams()
    const dispatch = useAppDispatch()
    const loading = useAppSelector((state) => state.product.loading)
    const error = useAppSelector((state) => state.product.error)

    useEffect(() => {
        if (!productName) return
        if (error) {
            window.location.pathname = "/404"
            return
        }
        dispatch(fetchProduct(productName))
    }, [productName, error])

    return (
        <Container id="productPageContainer" className="mt-4">
            <Row>
                <Col xs={12} className="pt-md-3" style={{ minHeight: "90vh" }}>
                    <SpinnerContainer enabled={loading} >
                        {!error &&
                            <>
                                <Row>
                                    <ProductImage />
                                    <ProductInfo />
                                </Row>
                                <Row>
                                    <Col xs={12} xl={10}>
                                        <ProductParams />
                                        <ProductDescription />
                                        <ProductCEO />
                                        <ProductTables />
                                    </Col>
                                    <ProductRecomendations />
                                </Row>
                            </>
                        }
                    </SpinnerContainer>
                </Col>
            </Row>
        </Container >
    )
}